import React, { useCallback, useEffect, useState } from 'react';

import { invoiceToTreatManuallyIcon } from '@europrocurement/l2d-icons';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { DataSource } from '@europrocurement/l2d-redux-utils';
import {
    AchatsAppDispatch,
    CategorieStats,
    CategorieStatsSelector,
    CodeRejetStats,
    CodeRejetStatsSelector,
    FactureAchat,
    FactureachatSelector,
    factureAchatsFiltersToElasticQuery,
    FACTURES_ACHATS_STATS_DATASOURCE_NAME,
    useAchatsService,
    useSociete,
} from '@europrocurement/l2d-domain';

import WidgetWithAction from './components/WidgetWithAction';

const FacturesATraiterManuellement: React.FunctionComponent = function () {
    const dispatch = useDispatch<AchatsAppDispatch>();
    const navigate = useNavigate();

    const xIdSociete = useSociete();

    const { factureAchatApi, getCategorieStats, getCodeRejetStats, getFactureAchatStats } =
        useAchatsService();

    const categoriesDataSource: DataSource<CategorieStats> =
        useSelector(CategorieStatsSelector).main;
    const codesRejetsDataSource: DataSource<CodeRejetStats> =
        useSelector(CodeRejetStatsSelector).main;
    const facturesAchatsDataSource: DataSource<FactureAchat> =
        useSelector(FactureachatSelector)[FACTURES_ACHATS_STATS_DATASOURCE_NAME];

    const [
        countOfUnregisteredInvoicesToTreatManually,
        setCountOfUnregisteredInvoicesToTreatManually,
    ] = useState<string>();

    useEffect(() => {
        factureAchatApi
            .getFacturesAchatsFactureAchatCollection(
                factureAchatsFiltersToElasticQuery({
                    xIdSociete,
                    search: '',
                    orders: [],
                    pagination: {
                        page: 0,
                        itemsPerPage: 0,
                    },
                    filters: {
                        cloture: true,
                        deleted: false,
                        categories: ['VE'],
                    },
                }),
            )
            .then((res) => {
                if (
                    res.data['hydra:totalItems'] !== null ||
                    res.data['hydra:totalItems'] !== undefined
                ) {
                    setCountOfUnregisteredInvoicesToTreatManually(
                        `${res.data['hydra:totalItems']}`,
                    );
                }
            });
    }, [factureAchatApi, xIdSociete]);

    const clearPreviousFilters = useCallback(() => {
        dispatch({
            type: `${categoriesDataSource.slicename}/resetmainFilter`,
        });
        dispatch({
            type: `${codesRejetsDataSource.slicename}/resetmainFilter`,
        });
        dispatch({
            type: `${facturesAchatsDataSource.slicename}/reset${FACTURES_ACHATS_STATS_DATASOURCE_NAME}Filter`,
        });
    }, [
        categoriesDataSource.slicename,
        codesRejetsDataSource.slicename,
        dispatch,
        facturesAchatsDataSource.slicename,
    ]);

    const applyFilters = useCallback(() => {
        dispatch({
            type: `${categoriesDataSource.slicename}/setmainFilter`,
            payload: {
                key: 'categories',
                value: ['VE'],
            },
        });
        dispatch({
            type: `${categoriesDataSource.slicename}/set${categoriesDataSource.name}Filter`,
            payload: {
                key: 'idSociete',
                value: xIdSociete,
            },
        });
    }, [categoriesDataSource.name, categoriesDataSource.slicename, dispatch, xIdSociete]);

    const beforeActionCallback = useCallback(() => {
        clearPreviousFilters();
        applyFilters();
    }, [applyFilters, clearPreviousFilters]);

    const actionCallback = useCallback(async () => {
        await Promise.all([
            dispatch(getCategorieStats({})),
            dispatch(getCodeRejetStats({})),
            dispatch(getFactureAchatStats({})),
        ]);
    }, [dispatch, getCategorieStats, getCodeRejetStats, getFactureAchatStats]);

    const onActionSuccessCallback = useCallback(() => {
        navigate('/achats/stats?tab=detail');
    }, [navigate]);

    return (
        <Grid
            sx={{
                flex: 1,
            }}
            item
            lg={1}
            md={1}
            xs={12}
        >
            <WidgetWithAction
                title="Factures à traiter manuellement"
                icon={invoiceToTreatManuallyIcon}
                actionMessage="Traiter"
                actionCallback={actionCallback}
                data={countOfUnregisteredInvoicesToTreatManually}
                paragraph="Factures en VEAA, VEADJ, VEMP :"
                color="VE"
                loadingMessage="Application des filtres..."
                beforeActionCallback={beforeActionCallback}
                onActionSuccessCallback={onActionSuccessCallback}
            />
        </Grid>
    );
};

export default FacturesATraiterManuellement;
